function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.8,
  width: 162.463,
  height: 162.463,
  rx: 40,
  transform: "matrix(0.866044 0.499967 -0.866044 0.499967 141.696 0.557617)",
  fill: "#F2F2F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.4,
  width: 162.463,
  height: 162.463,
  rx: 40,
  transform: "matrix(0.866044 0.499967 -0.866044 0.499967 141.696 16.3281)",
  fill: "#F2F2F2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "#000"
}, React.createElement("path", {
  d: "M142.365 88.7908L131.236 82.3664L133.596 81.0042L144.724 87.4286L142.365 88.7908ZM151.819 83.3331L149.459 84.6953L140.294 79.4047L137.273 81.1492L135.309 80.0155L143.712 75.1642L145.676 76.2979L142.654 78.0425L151.819 83.3331Z",
  fill: "#333333"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 138.094,
  height: 23.2134,
  fill: "white",
  transform: "matrix(0.866044 -0.499967 0.866044 0.499967 71.8464 110.502)"
})));

var SvgIt = function SvgIt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 283,
    height: 179,
    viewBox: "0 0 283 179",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IT.b7d206bf.svg";
export { ForwardRef as ReactComponent };